import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import DetailModal from "./processComponent/DetailModal";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import HeaderComponent from "./processComponent/HeaderComponent";
import axios from "axios";
import "./WmsPoPhysicalStockCountSetup.css";
import { getGlobals } from "../../Configs";
import moment from "moment";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { confirmAlert } from "react-confirm-alert";

const WmsPoPhysicalStockCountSetup = () => {
  const uMediaQuery = useMediaQuery("(max-width:390px)");
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const xMediaQuery = useMediaQuery("(max-width:950px)");
  const aMediaQuery = useMediaQuery("(max-width:1300px)");
  const status = ["All", "Enter", "Post"];

  const [settingSummary, setSettingSummary] = useState([]);
  const [open, setOpen] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // Store full row data
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const LocWithRights = useSelector((state) => state.SliceGRNLocation.value);
  const [filterState, setFilterState] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toISOString(),
    dateTo: new Date().toISOString(),
    location: LocWithRights.length > 0 ? LocWithRights[0]?.UID : [],
    status: "All",
    countStatus: "All",
    varianceStatus: "All",
    finalPosting: "All",
  });

  const baseURL = getGlobals().API_BASE_URL;

  const handleLoadBtn = () => {
    getSettingSummary();
    if (vMediaQuery) {
      setOpenFilterModal(false);
    }
  };

  const handleRowClick = (params) => {
    setSelectedRow(params.row);
    setOpen(true);
  };

  const handleAddNew = () => {
    setSelectedRow({
      A_SheetId: 0,
      A_Date: new Date(),
      A_RefNo: "",
      A_Loc: LocWithRights.length > 0 ? LocWithRights[0]?.UID : [],
      A_Narration: "",
      A_Status: "ENTER",
      A_CountStatus: "",
      A_VarianceStatus: "",
      A_FinalPosted: "",
      CreatedBy: "",
      CreatedDt: "",
      A_UserCd: "",
    });
    setOpen(true);
  };

  const fFilter = () => {
    setOpenFilterModal(true);
  };
  const getSettingSummary = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}physicalstock/WMPOIPT00A_Summary`,
        fcheck_null_undefine_replace_empty({
          FromDate: moment(filterState?.dateFrom).format("MM/DD/YYYY"),
          ToDate: moment(filterState?.dateTo).format("MM/DD/YYYY"),
          Location: filterState?.location,
          Status: filterState?.status,
          UserCd: vRdxuserInfo?.UserID,
        })
      );

      if (response?.data) {
        setSettingSummary(response?.data?.recordset);
        loader.style.display = "none";
      }
    } catch (error) {
      console.error("Error fetching cycle count data:", error);
      loader.style.display = "none";
    }
  };
  const handleDeleteClick = (row) => {
    confirmAlert({
      title: "Delete",
      message: "Are you want to delete?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            deleteRowApi(row);

            setTimeout(() => {
              document.getElementsByName("itemName")[0].focus();
            }, 600);
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };
  const deleteRowApi = async (row) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}physicalstock/WMPOIPT00_Head_Detail_Delete`,
        fcheck_null_undefine_replace_empty({
          SheetId: row?.A_SheetId,
        })
      );

      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Line items deleted successfully");
        getSettingSummary();
        loader.style.display = "none";
      }
    } catch (error) {
      loader.style.display = "none";
      let errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurredddddd.";
      fAlertToast("FAILED", `${errorMessage}`);
    }
  };

  useEffect(() => {
    getSettingSummary();
  }, []);

  return (
    <div className="div-container">
      <Box pt={2}>
        {vMediaQuery ? (
          <Grid container>
            <Grid item xs={6} marginTop={uMediaQuery ? 0.5 : 0}>
              <Typography
                variant={vMediaQuery ? "subtitle2" : "h6"}
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: 600, mt: 0.5 }}
              >
                Physical Stock Setting
              </Typography>
            </Grid>
            <Grid item xs={3} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fFilter}
              >
                Filter
              </Button>
            </Grid>
            <Grid item xs={3} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={handleAddNew}
              >
                New
              </Button>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography
              variant="h6"
              gutterBottom
              color={"primary"}
              sx={{ fontWeight: 600 }}
            >
              Physical Stock Setting
            </Typography>

            <HeaderComponent
              handleAddNew={handleAddNew}
              status={status}
              filterState={filterState}
              setFilterState={setFilterState}
              vRdxDBLocation={LocWithRights}
              handleLoadBtn={handleLoadBtn}
            />
          </>
        )}

        <Box
          sx={{
            mt: vMediaQuery ? 4 : 5,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            height: vMediaQuery ? "80vh" : xMediaQuery ? "65vh" : "72vh",
            width: "100%",
          }}
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            components={{
              Toolbar: GridToolbar,
            }}
            //  className="grid-table"
            rows={settingSummary ? settingSummary : ""}
            getRowId={(v) => v.A_SheetId}
            columns={[
              {
                field: "view",
                headerName: "View",
                width: 40,
                sortable: false,
                filterable: false,
                renderCell: (params) => (
                  <>
                    <IconButton
                      size="small"
                      onClick={() => handleRowClick(params)} // call same row click logic
                      title="View"
                      color="primary"
                    >
                      <VisibilityRoundedIcon fontSize="small" />
                    </IconButton>
                  </>
                ),
              },
              {
                field: "actions",
                headerName: "Delete",
                width: 40,
                sortable: false,
                filterable: false,
                renderCell: (params) => (
                  <>
                    <IconButton
                      size="small"
                      onClick={() => handleDeleteClick(params.row)}
                      title="Delete"
                      color="error"
                      disabled={params.row.A_Status === "POST"}
                    >
                      <DeleteRoundedIcon fontSize="small" />
                    </IconButton>
                  </>
                ),
              },
              {
                field: "A_SheetId",
                headerName: "Sheet.ID",
                width: xMediaQuery ? 80 : 100,
              },
              {
                field: "A_Date",
                headerName: "Date",
                width: 95,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY"),
              },
              {
                field: "A_RefNo",
                headerName: "Ref.No",
                width: xMediaQuery ? 80 : 100,
                hide: true,
              },
              {
                field: "UserName",
                headerName: "Name",
                width: 200,
              },
              {
                field: "LocName",
                headerName: "Location",
                width: aMediaQuery ? 150 : 0,
                flex: aMediaQuery ? 0 : 1,
              },
              {
                field: "A_Status",
                headerName: "Status",
                width: 80,
              },
              {
                field: "A_Count_Status",
                headerName: "Count",
                width: 80,
              },
              {
                field: "A_Vari_Status",
                headerName: "Variance",
                width: 80,
              },
              {
                field: "A_Adj_Status",
                headerName: "Adjustment",
                width: xMediaQuery ? 80 : 100,
              },
              // {
              //   field: "A_Narration",
              //   headerName: "Narration",
              //   width: aMediaQuery ? 150 : 0,
              //   flex: aMediaQuery ? 0 : 1,
              //   hide: aMediaQuery ? true : false,
              // },
              {
                field: "CreatedBy",
                headerName: "Created By",
                width: 150,
              },
              {
                field: "CreatedDt",
                headerName: "Created Date",
                width: 95,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY"),
              },
            ]}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
            }}
            // onRowClick={handleRowClick}
          />
        </Box>
        <CycleCustomModal
          open={open}
          onClose={() => {
            setOpen(false);
            getSettingSummary();
          }}
          vMediaQuery={vMediaQuery}
          xMediaQuery={xMediaQuery}
          title="Stock Setting Detail"
        >
          <DetailModal
            open={open}
            closeModal={() => {
              setOpen(false);
              getSettingSummary();
            }}
            vMediaQuery={vMediaQuery}
            uMediaQuery={uMediaQuery}
            rowData={selectedRow} // Pass full row data to modal
            xMediaQuery={xMediaQuery}
          />
        </CycleCustomModal>

        <CycleCustomModal
          open={openFilterModal}
          onClose={() => setOpenFilterModal(false)}
          vMediaQuery={vMediaQuery}
          xMediaQuery={xMediaQuery}
          title="Filter"
        >
          <HeaderComponent
            closeModal={() => setOpenFilterModal(false)}
            status={status}
            handleLoadBtn={handleLoadBtn}
            filterState={filterState}
            setFilterState={setFilterState}
            vRdxDBLocation={LocWithRights}
          />
        </CycleCustomModal>
      </Box>
    </div>
  );
};

export default WmsPoPhysicalStockCountSetup;
